import React, { useState } from "react";
import DevisForm from "./DevisForm";
import "./contactFooter.scss";
import { useScrollLock } from "../hooks/useScrollLock";

const ContactFooter = () => {
  const [showForm, setShowForm] = useState(false);

  // Utiliser le hook pour bloquer le scroll quand le formulaire est ouvert
  useScrollLock(showForm);

  return (
    <>
      <section className="contact-footer">
        <div className="inner">
          <div className="content">
            <div className="text-content">
              <h2>Besoin d'une intervention urgente ou d'un devis gratuit ?</h2>
              <p>
                Contactez-nous dès maintenant pour une solution adaptée à votre
                situation !
              </p>
            </div>
            <div className="form-content">
              <button
                className="call-to-action"
                onClick={() => setShowForm(true)}
              >
                Demander un devis gratuit
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Popup DevisForm */}
      {showForm && (
        <div className="devis-popup-overlay" onClick={() => setShowForm(false)}>
          <div className="devis-popup" onClick={(e) => e.stopPropagation()}>
            <button
              className="devis-popup-close"
              onClick={() => setShowForm(false)}
            >
              ×
            </button>
            <DevisForm />
          </div>
        </div>
      )}
    </>
  );
};

export default ContactFooter;
